var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Photovoltaic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.235.21l-4.709 12h14.369l4.579-12H5.234zm5.144 1.264h2.95L12.33 4H9.387l.992-2.526zm1.579 3.474l-.992 2.526H8.03l.985-2.526h2.943zM6.21 1.474H9.16L8.168 4H5.222l.989-2.526zM4.85 4.948h2.94l-.992 2.526H3.864l.986-2.526zm.587 6h-2.94l.991-2.527h2.947l-.998 2.527zm4.162 0h-2.94l.992-2.527h2.946l-.998 2.527zm4.165 0h-2.94l.992-2.527h2.943l-.995 2.527zm1.368-3.474h-2.94l.985-2.526h2.946l-.991 2.526zM13.552 4l.992-2.526h2.95L16.499 4h-2.946z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Photovoltaic.35e8f29f.svg";
export { SvgF1Photovoltaic as ReactComponent };